import {
    destroyData,
    uploadData,
    getDataWithParams

} from '@/store/api/method-mbkm'

const itemInit = {
    id: null,
    studyprog_exc_id: null,
    name: null,
    sks: null,
    code: null,
    quota: null,
    stdCourseQuota: null,
    universitas: null,
    nama_prodi: null,
    nama_matkul: null,
    semester_name:null,
    type:null,
    deskripsi: null,
    study_program_name: null,
    status: null,
    stdcourseStatus: [
        {
            class: "y-alert-error",
            value: "Ditutup",
            id: 0
        },
        {
            class: "y-alert-success",
            value: "Dibuka",
            id: 1
        },
    ],
    //Pemanggilan Universitas Tujuan
    univ_name: null
}

const requestInit = {
    page: 1,
    show: 10,
    sortBy: "created_at",
    sorting: "ASC",
    search: null,
    filter: null,
    response: {}
}
const initialState = () => ({
    data: {},
    msg: "Jaringan Bermasalah",
    status: 0,
    request: {...requestInit},
    item: {...itemInit},
    response: {},
    stdcourseStatus: [
        {
            class: "y-alert-error",
            value: "Ditutup",
            id: 0
        },
        {
            class: "y-alert-success",
            value: "Dibuka",
            id: 1
        },
    ]
})

const state = initialState

const getters = {
    getData: state => state.data || {},
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getItem: state => state.item,
    getResponse: state => state.response,
    getStudyCourseStatus: state => state.stdcourseStatus

}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = '0'
    },
    SET_MSG_FAILED(state, err) {
        if (err.status == 400) {
            state.msg = err.data.response
            state.status = err.data.status
        } else {
            state.msg = 'Jaringan Bermasalah'
            state.status = '0'
        }
    },
    SET_RESPONSE(state, response) {
        state.response = {
            msg: response.msg,
            status: response.status
        }
        
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_REQUEST(state, value) {
        state.request = value
    },
    SET_ITEM(state, value) {
        state.item = value
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}


const actions = {
    setRequest({commit}, value){
        commit('SET_REQUEST',value)
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    resetItem({commit}){
        commit('SET_ITEM', {...itemInit})
    },
    resetRequest({commit}){
        commit('SET_REQUEST', {...requestInit})
    },
    async getAllData({commit, state} ,role) {
        try {
            var url = null
            if(role=='kaprodi')
            {
                url = '/studentexchange-stdcourse'
            }
            else{
                url = '/studentexchange-superadmincourse'
            }
            const response = await getDataWithParams(url, state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async store({commit }, data) {
        try {
            const response = await uploadData('/studentexchange-stdcourse', data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async update({commit }, {id, data}) {
        try {
            const url = `/studentexchange-stdcourse/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async destroy({commit }, id) {
        try {
            const url = `/studentexchange-stdcourse/${id}`
            const response = await destroyData(url)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async openStudyCourse({commit }, {id, data}) {
        try {
            const url = `/studentexchange-stdcourse/isOpen/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

}




export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}